module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/kiosk-edit-dialog/kiosk-edit-dialog.component.css
// module id = ./src/app/kiosk-edit-dialog/kiosk-edit-dialog.component.css
// module chunks = main